import React from "react";
import { formatDays, getAvailableBalance, getBalanceType } from "../utils/leaveHelpers";
import LeaveAccrualProgress from "./LeaveAccrualProgress";
import "./LeaveBalanceCard.css";

export default function LeaveBalanceCard({ balance }) {
  const type = getBalanceType(balance);
  return <article className="se-leave-summary-card" aria-label={`${balance.displayName || type.name || "Leave"} balance`}>
    <header className="se-leave-summary-card-head">
      <div className="se-leave-summary-card-identity"><span className="se-leave-summary-card-code">{balance.displayCode || type.code || "LV"}</span><div><h3>{balance.displayName || type.name || "Leave"}</h3><p>{balance.year || new Date().getFullYear()}</p></div></div>
      <div className="se-leave-summary-card-available"><span>Available</span><strong>{formatDays(getAvailableBalance(balance))}<small> days</small></strong></div>
    </header>
    <div className="se-leave-summary-card-usage"><span>Used <strong>{formatDays(balance.used)}</strong></span><span>Pending <strong>{formatDays(balance.pending)}</strong></span></div>
    <LeaveAccrualProgress balance={balance} />
  </article>;
}
